import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'leaflet/dist/leaflet.css';
import VueApexCharts from 'vue-apexcharts'
import DateFormat from '@/util/date'
import Signalr from '@/util/signalr'
Vue.use(VueApexCharts)
Vue.component('apex-chart', VueApexCharts)
Vue.config.productionTip = false
Vue.use(DateFormat, {});
Vue.use(Signalr, {});

console.log(process.env.NODE_ENV);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
